import gql from "graphql-tag";

/**
 * Graphql mutation for uploading a certificate document
 */
const UploadCertificateDocument = gql`
  mutation($input: CertificateDocumentInput!) {
    UploadShippingRequestSupportingDocument(input: $input) {
      id
      shipping_request_id
      file_url
      file_name
    }
  }
`;

export default UploadCertificateDocument;
